export default __webpack_public_path__ + "static/media/image.www-myherbals-lk.ab48fb09.png";